// extracted by mini-css-extract-plugin
module.exports = {"card":"PageWithTag-module--card--3SyDv","tagHeading":"PageWithTag-module--tagHeading--22rcS"};